<template>
    <component v-bind:is="item.AdvocacyAlertUrl != '' ? 'a' : 'a'"
               v-bind:href="item.AdvocacyAlertUrl"
               v-bind:target="(item.Url.indexOf('/') == 0 ? '_self' : '_blank')"
               class="card card-horizontal card-outer card-callout">

        <div class="card-content">
            <span class="icon icon-arrow-right"></span>
            <h2 v-if="item.AdvocacyAlertTitle">{{ item.AdvocacyAlertTitle }}</h2>
            <p v-if="item.PreviewText">{{ item.PreviewText }} <span class="cta-link no-left-margin">Take Action</span></p>

                <!--<div v-if="item.disease_category" class="card-tags">
                    <span>Diseases:</span>
                    <ul>
                        <li class="accent" v-for="disease in item.disease_category.split('|')">{{ disease }}</li>
                    </ul>
                </div>

                <div v-if="item.issue_topic" class="card-tags">
                    <span>Topics:</span>
                    <ul v-if="item.issue_topic">
                        <li class="accent" v-for="topic in item.issue_topic.split('|')">{{ topic }}</li>
                    </ul>
                </div>-->

                <div v-if="item.CategoryDisplayNames && item.CategoryDisplayNames.length" class="card-tags">
                    <span>Topics:</span>
                    <ul>
                        <li v-for="category in item.CategoryDisplayNames">{{ category }}</li>
                    </ul>
                </div>

        </div>
    </component>
</template>

<script>
    import FilterGroup from '../ui/filter-group';

	export default {
		props: ['item', 'displaySummary', 'issue_topic', 'disease_category', 'CategoryDisplayNames'],
		components: {
            'filter-group': FilterGroup,
		},
		mounted: function () {

		},
		methods: {
			formatDate(date) {
				return DateFormatService.formatDate(date);
			},
        },
    }
</script>